import { StayRow } from "../models/StayRow";
import { stayDurationHours } from "./stayRows";

export type StayField = "deviceName" | "zoneName" | "zoneTypes" | "entry" | "exit" | "durationHours" | "note";

export interface StayNoteLabels {
  ongoing: string;
  zoneUnknown: string;
}

/**
 * The typed value of one cell – what the grid sorts by and what the Excel export writes. A stay still
 * running has no exit and no duration, so a report's sum is the same whenever it is exported.
 */
export function stayCellValue(row: StayRow, field: StayField, labels: StayNoteLabels): Date | number | string | null {
  switch (field) {
    case "entry":
      return row.entry;
    case "exit":
      return row.exit;
    case "durationHours":
      return stayDurationHours(row);
    case "note":
      return row.ongoing ? labels.ongoing : row.zoneFound ? "" : labels.zoneUnknown;
    default:
      return row[field];
  }
}
